import React from 'react'
import * as base from 'components/BandSlider/BandSlider.module.scss'
import * as theme from 'components/BandSlider/BandSlider-theme.module.scss'

let styles = {}
Object.assign(styles, base, theme)

/*
  technique from
  https://ryanmulligan.dev/blog/css-marquee/
  https://codepen.io/hexagoncircle/pen/wvmjomb

*/

/**
 * Every prop past `gap` is optional and defaults to the original rendering, so
 * the sites already using this component (fifaunilever, beautyu, fifa-demo) are
 * untouched, as is the Puck BandSlider block that wraps it.
 *
 * @param {number} repeat  How many times the image list is repeated inside each
 *   marquee group. `.marqueeGroup` is `min-width: 100%` with
 *   `justify-content: space-around`, so a short list (two images, say) is spread
 *   across the viewport and shows gaps even with gap and margin at zero.
 *   Repeating until the natural width passes 100% leaves no slack to distribute.
 *   The loop stays seamless at any width because `translateX(-100%)` is relative
 *   to the group's own width.
 */
export const BandSlider = ({
  images: imagesProp,
  speed = '120s',
  gap = '20px',
  imageHeight,
  imageMargin,
  background,
  direction = 'left',
  repeat = 1,
}) => {
  const style = {
    '--duration': speed,
    '--gap': gap,
    ...(imageHeight ? { '--img-height': imageHeight } : {}),
    ...(imageMargin ? { '--img-margin': imageMargin } : {}),
    ...(background ? { '--band-background': background } : {}),
    ...(direction === 'right' ? { '--band-direction': 'reverse' } : {}),
  }

  const times = Math.max(1, Math.floor(Number(repeat) || 1))
  const images =
    times > 1
      ? Array.from({ length: times }).flatMap(() => imagesProp)
      : imagesProp

  return (
    <div id="band-slider" className={styles.root} style={style}>
      <div className={styles.marquee}>
        <div className={styles.marqueeGroup}>
          {[...images].map((image, i) => (
            <img className={styles.img} src={image} alt="" key={i} />
          ))}
        </div>
        <div className={styles.marqueeGroup} aria-hidden="true">
          {[...images].map((image, i) => (
            <img className={styles.img} src={image} alt="" key={i} />
          ))}
        </div>
      </div>
    </div>
  )
}
